<template>
  <section class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <h3>投注记录</h3>
      <span>每个场馆的数据将有一定时间的延迟，仅供参考使用</span>
    </div>
    <div class="myCenterCommon__users_layout__params__2DfEC">
      <div class="myCenterCommon__check_wrap__3bM7H">
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fl__waaJH" style="width: 35%">
          <div class="myCenterCommon__users_params__label__3y-Q5">选择游戏：</div>
          <div>
            <el-select v-model="api_type" placeholder="请选择平台" @change="changApiType">
              <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
       <div class="myCenterCommon__check_wrap__3bM7H">
        <div class="myCenterCommon__users_layout__params_item__MYZdv myCenterCommon__fr__3TeIF">
          <div class="myCenterCommon__users_params__label__3y-Q5">时间选择：</div>
          <el-radio-group v-model="date" @change="changeDate">
            <el-radio-button :label="1">今日</el-radio-button>
            <el-radio-button :label="2">一周内</el-radio-button>
            <el-radio-button :label="3">半月内</el-radio-button>
            <el-radio-button :label="4">一月内</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>

    <el-table :data="betrecordList" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="bet_time" label="时间" width="180"> </el-table-column>
      <el-table-column prop="bet_id" label="订单号" width="200"> </el-table-column>
      <el-table-column prop="Code" label="游戏名称"> </el-table-column>
      <el-table-column prop="bet_amount" label="金额"> </el-table-column>
      <el-table-column prop="win_loss" label="派彩"> </el-table-column>
      <el-table-column prop="status" label="状态" width="70">
        <template slot-scope="scope"> {{ statuType[scope.row.status] }} </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="betrecordShowData.total" style="margin: 20px 0 0px 120px" @current-change="getbetrecord" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="betrecordShowData.total"></el-pagination>
  </section>
</template>
<script>
export default {
  name: 'betRecord',
  data() {
    return {
      date: 4,
      betrecordList: [],
      page: 1,
      betrecordShowData: {},
      statuType: ['无效注单', '已结算', '未结算'],
      dogameLis: [],
      api_type: '',
    };
  },
  created() {
    let that = this;
    that.getdogame();
    that.getbetrecord();
  },
  methods: {
    changApiType() {
      let that = this;
      that.page = 1;
      that.getbetrecord();
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: '全平台', platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.getbetrecord();
    },
    // 获取投注记录
    getbetrecord() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun.post('/api/betrecord', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.betrecordList = res.data.data;
          that.betrecordShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/betRecord.vue